<template>
	<div class="w-full flex flex-col items-center">
		<div class="w-full px-4 2.5xl:px-0 max-w-8xl">
			<button
				@click="toggleVideo"
				class="w-full rounded-xl bg-ihh-pink text-ihh-midnight-gray px-3 pt-2 my-2 md:py-0 text-lg md:text-base active:scale-90 transition duration-200 focus:outline-none focus:ring-2 focus:ring-ihh-pink"
			>
				<div class="flex items-center justify-center">
					<img src="/images/play_icon.svg" class="w-12" />
					<!-- Mobile layout (flex-col) for small screens, row layout for md and up -->
					<div class="flex flex-col md:flex-row items-center justify-start">
						<!-- Close Video (when video is showing) -->
						<template v-if="showVideo">
							<div class="flex items-center justify-start">
								<div>Close Video</div>
								<img src="/images/chevron-left.svg" class="w-6" />
							</div>
						</template>
						<!-- Intro Video text (when video is not showing) -->
						<template v-else>
							<div class="md:flex md:items-center md:space-x-2">
								<div class="w-full md:w-auto text-start font-semibold leading-[0.75rem]">{{ 'Intro Video -' }}</div>
								<div class="flex items-center justify-start leading-[0.75rem]">
									<div>{{ 'Learn More About Us' }}</div>
									<img src="/images/chevron-right.svg" class="w-6" />
								</div>
							</div>
						</template>
					</div>
				</div>
			</button>
		</div>
		<transition
			enter-active-class="transition-all duration-500 ease-out"
			enter-from-class="opacity-0 max-h-0"
			enter-to-class="opacity-100 max-h-[600px]"
			leave-active-class="transition-all duration-500 ease-in"
			leave-from-class="opacity-100 max-h-[600px]"
			leave-to-class="opacity-0 max-h-0"
		>
			<div v-if="showVideo" class="w-full max-w-4xl overflow-hidden mt-4">
				<iframe
					src="https://player.vimeo.com/video/1026264453?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
					class="aspect-video rounded-xl w-full mx-auto bg-rum-100"
					frameborder="0"
					allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
					title="In His Hands Video"
				/>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showVideo: false,
		}
	},
	methods: {
		toggleVideo() {
			this.showVideo = !this.showVideo
		},
	},
}
</script>
